export default __webpack_public_path__ + "static/1162-5629c534d44e578f80e6a94dd70faeae.gif";